/**
 * Ustawia minimalną wysokość <body>
 */
app.service('footer',function(html){
	var $body, $self, $collapsibleRow, $collapseButton;

	function setElements() {
		$body = $('body');
		$self = $('#main-footer');
		$collapsibleRow = $('#footer-links');
		$collapseButton = $('.js-toggle-footer-links');
	}

	function setStyles() {
		$body.css({
			'min-height': 'calc(100vh - '+($self.outerHeight())+'px)',
			'padding-bottom': ($self.outerHeight() + parseInt($self.css('margin-bottom')))+'px'
		});
		html.add('footer2bottom');
	}
	function setAriaAndFocus() {
		const isExpanded = $collapsibleRow.hasClass('open');
		$collapseButton.attr('aria-expanded', isExpanded);
		if (isExpanded) {
			// Autofocus na pierwszy dotychczas ukryty element listy w stopce
			$collapsibleRow.find('.focus-after-open li:first-child a').focus();
		}
	}

	function setEvents() {
		$(window).resize(setStyles);
		window.onload = setStyles;
		$collapseButton.on('click', function(){
			$collapsibleRow.toggleClass('open');
			setStyles();
			setAriaAndFocus();
		});
	}

	function init() {
		setElements();
		setStyles();
		setEvents();
	}

	return {
		init:init
	};
});
